const toDate = (value: any, a: string, b: string) =>
  (value || '').split(a).reverse().join(b);
const fromUtc = (value: any) => toDate(value, '-', '.');
const fromFullUtc = (value: any) => {
  const date = value.split(' ')[0];
  return date ? toDate(date, '-', '.') : '';
};

export { fromUtc, fromFullUtc };



// WEBPACK FOOTER //
// ./src/tools/formatedate.ts